<template>
  <MultipleAreaBase
    v-model="inputedValue"
    :width="width"
    :title="title"
    :pageData="pageData"
    :tables="pageData"
    :isFooter="isFooter"
    :isExpansionPanelFooter="true"
  >
    <template v-slot:[pageData[0].name]>
      <v-container fluid class="pa-0">
        <v-row no-gutters class="ma-10">
          <v-col cols="12" class="mr-16">
            <InputFormNew
              v-model="localPageInfoData.line1"
              :detail="pageInfoDetail.line1"
              :titleCols="inputFormStyle.titleCols"
              :contentsCols="inputFormStyle.contentsCols"
            >
              <template #remarks="{ item }">
                <v-textarea
                  outlined
                  v-model="item.remarks"
                  :placeholder="$t('common.common_remarks-placeholder')"
                  hide-details
                ></v-textarea>
              </template>
            </InputFormNew>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template #expansionPanelFooter0>
      <v-container fluid>
        <v-row justify="end" class="ma-1">
          <div class="ma-2 btnStyle">
            <NormalButton
              :text="$t('common.input_order-send')"
              textSize="16px"
              height="40px"
              width="120px"
              btnClass="ml-auto"
              @click="sendOrderIncomplete"
            />
          </div>
        </v-row>
      </v-container>
    </template>
    <template v-slot:[pageData[1].name]="{ item }">
      <slot :name="pageData[1].name" v-bind:item="item" />
    </template>
    <template v-slot:[pageData[2].name]="{ item }">
      <slot :name="pageData[2].name" v-bind:item="item" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </MultipleAreaBase>
</template>

<script>
import MultipleAreaBase from '@/components/layouts/Dialogs/MultipleArea/MultipleAreaBase'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import NormalButton from '@/components/items/Buttons/NormalButton'
import { mapActions } from 'vuex'

export default {
  name: 'OrderIncompleteDialogBase',
  components: {
    MultipleAreaBase,
    InputFormNew,
    NormalButton
  },
  data: () => ({
    localPageInfoData: {},

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },

    // pageData 0
    pageInfoDetail: {
      line1: [
        {
          name: 'incompleteOrderReason',
          text: 'ship.ship_incomplete-order-reason',
          required: true,
          component: 'SelectIncompleteOrderReason',
          cols: 3
        },
        {
          name: 'remarks',
          text: 'ship.ship_remarks-column',
          required: true,
          textPositionStart: true
        }
      ]
    }
  }),
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    isFooter: { default: false },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    pageData: []
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    recItems: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        this.setInputData()
      }
    }
  },
  methods: {
    ...mapActions('Order', ['registerOrderIncomplete']),
    ...mapActions('Common', ['setIsLoading']),
    setInputData() {
      this.localPageInfoData = {
        line1: {
          incompleteOrderReason: { value: '', label: '' },
          remarks: ''
        }
      }
    },
    async sendOrderIncomplete() {
      this.setIsLoading(true)
      const params = {
        type: this.localPageInfoData.line1.incompleteOrderReason.value,
        content: this.localPageInfoData.line1.remarks,
        saleId: this.recItems.saleId
      }
      const isSucceed = await this.registerOrderIncomplete(params)
      if (isSucceed) {
        alert(this.$t('common.common_saved-alert'))
        this.$emit('complete')
      }
      this.setIsLoading(false)
    }
  }
}
</script>

<style scoped></style>
